import { render, staticRenderFns } from "./operacoes-instituicao.vue?vue&type=template&id=44e20f33&"
import script from "./operacoes-instituicao.vue?vue&type=script&lang=js&"
export * from "./operacoes-instituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports